module.exports = __webpack_public_path__ + "img/Zeus.e804cef0.png";